<ng-container *ngIf="configuration">
  <div class="row">
    <h1 class="text-primary text-primary text-center">Book a Birthday Party!</h1>
    <ua-wizard-stepper [currentStep]=3 (stepChange)="stepChange($event)"></ua-wizard-stepper>
  </div>

  <form [formGroup]="bookingForm">
    <div class="h1 text-primary text-center fw-bold mb-3">
      <div class="logo">
        <img src="/assets/logos/brand-logo.svg" height="75">
      </div>
      Guest Details
    </div>
    <div class="w-full fw-bold parent-guardian mb-4">
      Guest of Honor
    </div>
    <ng-container *ngFor="let gohFormGroup of guestsOfHonorFormGroups; let i=index">
      <div class="row mb-3">
        <div class="col-10" [formGroup]="gohFormGroup">
          <div>
            <input id="gohFirstName" class="form-control" type="text" placeholder="Enter first name"
                   formControlName="firstName"/>
            <ua-display-validation-errors name='First name' [control]="gohFormGroup.controls.firstName"
                                          [force]="formDirty"></ua-display-validation-errors>
          </div>
          <div>
            <input id="gohLastName" class="form-control mt-2" type="text" placeholder="Enter last name"
                   formControlName="lastName"/>
            <ua-display-validation-errors name='Last name' [control]="gohFormGroup.controls.lastName"
                                          [force]="formDirty"></ua-display-validation-errors>
          </div>

          <label for="gohDateOfBirth" class="mt-3">Guest of Honor's Birthday <span class="required-asterisk">*</span></label>
          <div>
            <input id="gohDateOfBirth" class="form-control" mask="M0/d0/0000" [leadZeroDateTime]="true"
                   formControlName="dateOfBirth" placeholder="MM/DD/YYYY"/>
            <ua-display-validation-errors name='Birthday' [control]="gohFormGroup.controls.dateOfBirth"
                                          [force]="formDirty"></ua-display-validation-errors>
          </div>
        </div>
        <div class="col-2">
          <div class="col-2 mt-4">
            <Button *ngIf="this.guestsOfHonorCount < this.maxGuestsOfHonor && i === 0"
                    class="btn btn-link m-0" type="button"
                    (click)="addGuestOfHonorGroup()">
              <fa-icon [icon]="faPlus" transform="grow-5"></fa-icon>
            </Button>
            <Button *ngIf="i > 0 && i + 1 === this.guestsOfHonorCount" class="btn btn-link m-0"
                    type="button"
                    (click)="removeGuestOfHonorGroup()">
              <fa-icon [icon]="faMinus" transform="grow-5"></fa-icon>
            </Button>
          </div>
        </div>
      </div>
    </ng-container>
  </form>
  <ng-container *ngIf="!user?.loggedIn">
    <div class="w-full fw-bold parent-guardian">
      Parent / Guardian
    </div>
    <ua-login [forceSignup]="true" [hideHeader]="true" [showTitle]="false" [preventNavigateAway]="true" (onSuccess)="onLoginSucess()"></ua-login>
  </ng-container>
  <ng-container *ngIf="user?.loggedIn">
    <button type="button" class="btn btn-primary btn-lg w-100 fw-bold" (click)="onLoginSucess()">
      Next
    </button>
  </ng-container>
</ng-container>
